var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v("done")]):_c('v-icon',{attrs:{"color":"red"}},[_vm._v("close")])
}
var staticRenderFns = []

export { render, staticRenderFns }